import type { Variant } from './types';

const VARIANTS = ['purple', 'blue', 'lime', 'yellow'] as const;

// Take first 2 words of unit name and return initials, capitalizing first letter
export function getAbbreviation(unitName: string): string {
	const initials = unitName
		.toLowerCase()
		.split(/[\s-]+/) // Split by spaces and hyphens
		.filter((w) => /^[a-z0-9]/.test(w)) // Filter out non-alphanumeric words (e.g. &, +)
		.map((w) => w[0]) // Keep only the first letter of each word
		.join('')
		.slice(0, 2); // Cap at 2 characters
	return initials.charAt(0).toUpperCase() + initials.slice(1); // Capitalise first letter
}

// Derive color variant deterministically from unit name character codes
export function getVariant(unitName: string): Variant {
	const charCodes = unitName.split('').reduce((a, b) => a + b.charCodeAt(0), 0);
	return VARIANTS[charCodes % VARIANTS.length];
}
